import React from 'react'

const CoreComponent27 = ({softwarebenifitbox}) => {
  return (
    <div>
         <div className="row">
              {softwarebenifitbox.map((val,i)=>(
                <div key={i} className={`col-md-6  position-sticky bg-white`}   style={{ zIndex:  3,top:90 }} >
                  <div className="border p-3 rounded-3 shadow " style={{marginBottom:30}}>
                    <img src={val.icon} alt="" className="mx-0 " style={{width:44,height:44}}/>
                    <h3 className="mt-3 mb-2 fs-5 h3-heading lh-base text-start ">{val.title}</h3>
                    <p className="fs-6 lh-base h3-para ">{val.desc}</p>
                  </div>
                </div>
              ))}

            </div>
    </div>
  )
}

export default CoreComponent27